import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reservation-tenants',
  templateUrl: './reservation-tenants.component.html',
  styleUrls: ['./reservation-tenants.component.css']
})
export class ReservationTenantsComponent implements OnInit {
  first = 0;
  filter: any = {};

  constructor() { }

  ngOnInit() {
    this.filter.dateFrom = new Date();
  }

}
